import styled from "styled-components";

import { T_HEADER_bold } from "../../global.style";

export const StyledInfoText = styled.div`
    ${T_HEADER_bold};
`;

export const StyledInfoWrapper = styled.div `
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
`;
